import { h, Fragment } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { ButtonLabel } from '@components/button'
import classnames from 'classnames'
import { withHydration } from '@util/hydrate'
import { useQueryString } from '@util/useQueryString'
import { isClient } from '@util/env'


function FilterTaxonomies({ select = null, taxonomies = [], updateSelected = () => {} }) {
	const [selected, setSelected] = useState(select)

	const set = name => {
		setSelected(selected === name ? null : name)
		updateSelected(selected === name ? null : name)
	}

	const numFilters = taxonomies.length
	if (numFilters < 2) return <div></div>

	return <div>
		{taxonomies.map(taxonomy => <>
			<ButtonLabel 
				rounded 
				class="margin-top-1" 
				onClick={() => set(taxonomy.slug)} 
				active={selected === taxonomy.slug}>
				{taxonomy.name}
			</ButtonLabel>
			{' '}	
		</>)}
	</div>
}

function FiltersTaxonomiesUrl({ taxonomies = [] }) {
	const [query, updateQuery] = useQueryString('show')
	const style = `
		.filter-container [data-filter]:not([data-filter~="${query}"]) { display:none !important; }
	`
	return <>
		{query && <style>{style}</style>}
		<FilterTaxonomies 
			taxonomies={taxonomies}
			select={query} 
			updateSelected={selected => updateQuery(selected)} 
		/>

	</>
}

export const FilterTaxonomiesLive = withHydration(FiltersTaxonomiesUrl, 'FilterTaxonomiesLive')


export function FilterContainer({ children, ...props }) {
	const classes = classnames(
		'filter-container',
		props.class,
		props.className
	)
	delete props.class
	delete props.className
	return <div class={classes} {...props}>
		{children}
	</div>
}